import { Box, Button, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Typography, useMediaQuery } from "@mui/material"
import InputBasic from "../ProfilesComp/InputsBasic"
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import theme from "../../../themes/theme";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useDispatch, useSelector } from "react-redux";
import { updateSection } from "../../../store/Profiles/profilesSlice";

const StepCaseManaQues = ({ onNext, onBack }) => {
    const dispatch = useDispatch();
    const storedData = useSelector(state => state.profiles.CaseManagementQuestionnaire);
    const { t } = useTranslation();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("md")); // Detecta pantallas pequeñas
    const [formData, setFormData] = useState({
        PatientID: "",
        DateOfAssessment: "",
        PatientFullName: "",
        LocationOfAssessment: "",
        WasInformationObtainedDuring: "",
        IfYesWho: "",
        Relationship: "",
        Phone: ""
    });

    useEffect(() => {
        if (storedData) {
            setFormData(storedData);
        }
    }, [storedData]);

    const handleChange = (field, value) => {
        setFormData((prevData) => ({
            ...prevData,
            [field]: value
        }));
    };

    const handleNextStep = async () => {
        await handleSaveData(); // 🔹 Espera que termine antes de seguir
        onNext();
    };

    const handleSaveData = async () => {
        dispatch(updateSection({ section: "CaseManagementQuestionnaire", data: { CaseManagementQuestionnaire: formData } }));
    };

    return (
        <>
            <Typography variant="h5" gutterBottom>
                {t("Profiles.CaseManagementQuestionnaire.CaseManagementQuestionnaire")}
            </Typography>

            <Box component="form" noValidate autoComplete="off">
                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: isSmallScreen ? "1fr" : "1fr 1fr",
                        gap: 2,
                        mt: 2,
                    }}
                >
                    <InputBasic 
                        Translation="Profiles.CaseManagementQuestionnaire.PatientID"
                        value={formData.PatientID}
                        onChange={(e) => handleChange("PatientID", e.target.value)}
                    />
                    <InputBasic 
                        Translation="Profiles.CaseManagementQuestionnaire.DateOfAssenssmant"
                        type="date" 
                        InputLabelProps={{ shrink: true }} 
                        value={formData.DateOfAssessment}
                        onChange={(e) => handleChange("DateOfAssessment", e.target.value)}
                    />
                </Box>  

                <InputBasic 
                    Translation="Profiles.CaseManagementQuestionnaire.Patient’sfullname" 
                    margin="normal"
                    value={formData.PatientFullName}
                    onChange={(e) => handleChange("PatientFullName", e.target.value)}
                />
                <InputBasic 
                    Translation="Profiles.CaseManagementQuestionnaire.LocationofAssessment" 
                    margin="normal"
                    value={formData.LocationOfAssessment}
                    onChange={(e) => handleChange("LocationOfAssessment", e.target.value)}
                />

                <FormControl component="fieldset" margin="normal" sx={{ width: "100%", textAlign: "left" }}>
                    <FormLabel 
                        component="legend" 
                        sx={{ textAlign: "left", display: "block" }} // 🔹 Forzar alineación izquierda
                    >
                        {t("Profiles.CaseManagementQuestionnaire.Wasinformationobtainedduring")}
                    </FormLabel>
                    <RadioGroup
                        row
                        sx={{ justifyContent: "flex-start" }} // 🔹 Alineación de los botones a la izquierda
                        value={formData.WasInformationObtainedDuring}
                        onChange={(e) => handleChange("WasInformationObtainedDuring", e.target.value)}
                    >
                        <FormControlLabel value="yes" control={<Radio />} label={t("Profiles.Yes")} />
                        <FormControlLabel value="no" control={<Radio />} label={t("Profiles.No")} />
                    </RadioGroup>
                </FormControl>
                {formData.WasInformationObtainedDuring === "yes" && (
                    <Box sx={{ display: 'flex', gap: 2 }}>
                        <InputBasic 
                            Translation="Profiles.CaseManagementQuestionnaire.Ifyeswho?" 
                            value={formData.IfYesWho}
                            onChange={(e) => handleChange("IfYesWho", e.target.value)}
                        />
                        <InputBasic 
                            Translation="Profiles.CaseManagementQuestionnaire.Relationship" 
                            value={formData.Relationship}
                            onChange={(e) => handleChange("Relationship", e.target.value)}
                        />
                        <InputBasic 
                            Translation="Profiles.CaseManagementQuestionnaire.Phone" 
                            type="number" // 🔹 Esto solo permitirá números
                            value={formData.Phone}
                            onChange={(e) => handleChange("Phone", e.target.value)}
                        />
                    </Box>
                )}
            
                <Typography variant="h7" gutterBottom>
                    {t("Profiles.CaseManagementQuestionnaire.Pleaserefertothepatient’s")}
                </Typography>
            </Box>

            <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%", mt: 3 }}>
                <Button
                    startIcon={<ArrowBackIcon />}
                    onClick={onBack}
                    variant="outlined"
                    sx={{ position: "relative", left: 0 }}
                >
                    {t("common.back")}
                </Button>
                <Button
                    endIcon={<ArrowForwardIcon />}
                    onClick={handleNextStep}
                    variant="contained"
                    color="primary"
                    sx={{ position: "relative", right: 0 }}
                >
                    {t("common.next")}
                </Button>
            </Box>
        </>
    );
};

export default StepCaseManaQues;
